import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useAnalytics } from 'hooks';
import { PrimaryButton } from '@huggg/react-components'
import { getBasePathname } from 'utilities/huggg';
import { moreInformationPage } from 'config/dictionary';
import { Link } from 'react-router-dom'

const StashButton = props => {
  const { huggg, isStashed } = props;
  const analytics = useAnalytics();

  const onClick = useCallback(() => {
    analytics.buttonClickSuperhugggActionsStash()
  }, [analytics]);

  if (isStashed) {
    return null;
  }

  return (
    <Link
      to={`${getBasePathname(huggg)}/stash`}
      onClick={onClick}
      style={{ width: '320px', marginTop: '8px', textDecoration: 'none' }}
    >
      <PrimaryButton label={moreInformationPage.superhuggg.stashButton} />
    </Link>
  );
};

StashButton.propTypes = {
  huggg: PropTypes.object.isRequired,
  isStashed: PropTypes.bool.isRequired
};

export default StashButton;
